import React from 'react';
import { DuelOverlays } from './DuelOverlays';
import { PartyInvitePrompt } from './PartyInvitePrompt';

/**
 * The always-mounted overlays for other players reaching you: duel
 * challenges / duel HUD, and party invites and notices. Mounted from
 * src/main.tsx with the other HUD overlays, never from a window — a window's
 * listener only hears while that window is open (plan 23 row 41).
 */
export const SocialOverlays: React.FC = () => (
  <>
    <DuelOverlays />
    <PartyInvitePrompt />
  </>
);
